import { createSlice } from "@reduxjs/toolkit";

const ImageConfigReducer = createSlice({
  name: "imageConfig/reducer",

  initialState: {
    activeStep: 0,
    imageSelectedData: "",
    imageFormFilled: "",
    stateAction: "",
  },

  reducers: {
    imageSelectedData: (state, action) => {
      state.imageSelectedData = action.payload;
    },
    imageFormFilled: (state, action) => {
      state.imageFormFilled = action.payload;
    },
    stateAction: (state, action) => {
      state.stateAction = action.payload;
    },
    cloudType: (state, action) => {
      state.cloudType = action.payload;
    },
  },
});
export const {
  activeStep,
  imageSelectedData,
  imageFormFilled,
  stateAction,
  cloudType,
} = ImageConfigReducer.actions;
export const ImageDeatils = ImageConfigReducer.reducer;
